import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const NumDesigns = ({ handleChange, nextStep, formData, variant }) => {
  const handleSelectNum = num => {
    handleChange({ numDesigns: num });
    nextStep();
  };

  return (
    <StyledFormStep
      key="num-designs"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.25 }}
    >
      <h2>How many designs would you like?</h2>
      <div className="button-row">
        <StyledNumberBtn
          onClick={() => handleSelectNum(1)}
          active={formData.numDesigns === 1}
        >
          1
        </StyledNumberBtn>
        <StyledNumberBtn
          onClick={() => handleSelectNum(2)}
          active={formData.numDesigns === 2}
        >
          2
        </StyledNumberBtn>
        <StyledNumberBtn
          onClick={() => handleSelectNum(3)}
          active={formData.numDesigns === 3}
        >
          3
        </StyledNumberBtn>
        {variant !== 'boa' && (
          <StyledNumberBtn
            onClick={() => handleSelectNum(4)}
            active={formData.numDesigns === 4}
        >
          4
          </StyledNumberBtn>
        )}
      </div>
    </StyledFormStep>
  );
};

const StyledFormStep = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 50px 20px 100px;

  h2 {
    margin-top: 0;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
  }

  .button-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 40px;
    padding: 50px 20px;
    width: 100%;

    @media (max-width: 500px) {
      gap: 20px;
    }
  }
`;

const StyledNumberBtn = styled.button`
  background-color: ${props =>
    props.active === false ? '#b4b4b4' : 'var(--red)'};
  color: #fff;
  border-radius: 50%;
  border: none;
  width: 120px;
  aspect-ratio: 1 / 1;
  font-size: 50px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  @media (max-width: 767px) {
    width: 33%;
    font-size: 40px;
  }

  &:hover {
    background-color: #8d8b8b;
  }

  &:focus {
    background-color: var(--red);
  }
`;

export default NumDesigns;
